import { useState } from "react";
import { useTranslation } from "react-i18next";
// Components
import { InfoMainDiv, InfoButton, InfoText, InfoArrowImg, IndicatorDiv } from "./styles";
// Assets
import ArrowDown from "../../../../../assets/icons/ico_arrow_down_black.svg";
import ArrowUp from "../../../../../assets/icons/ico_arrow_up_black.svg";

const QuestionnaireInfo = () => {
  const [isShowInfo, setIsShowInfo] = useState(false);
  const [t] = useTranslation("global");

  return (
    <InfoMainDiv>
      <InfoButton onClick={() => setIsShowInfo(!isShowInfo)}>
        <InfoText>{t("informationButton_title")}</InfoText>
        <InfoArrowImg src={isShowInfo ? ArrowUp : ArrowDown} alt="arrow" />
      </InfoButton>
      <IndicatorDiv display={isShowInfo ? "flex" : "none"}>
        <InfoText>{t("questionnaires_questionnaireInfo")}</InfoText>
      </IndicatorDiv>
    </InfoMainDiv>
  );
};

export default QuestionnaireInfo;
